import { createContext } from 'react';
import type { LaunchDarklyContextState } from './LaunchDarklyContext.types';

export const LaunchDarklyContext = createContext<LaunchDarklyContextState>({
  loading: true,
  flags: {},
  ldClient: undefined,
  context: {
    kind: 'user',
    key: 'shared-anonymous',
    anonymous: true,
  },
});
